import React, { Component } from 'react';
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Input,
  FormGroup,
  Label,
  Row,
  Col,
  ButtonGroup,
  Button,
  Tooltip,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Disclaimer from '../../../components/Disclaimer';
import AllPlans from './AllPlans';
import MyPlans from './MyPlans';
import { saveHideUnpublishedPlans, saveNewViewModel } from '../../../actions';
import {
  Storages,
  itemExists,
  getFromLocalStorage,
} from '../../../services/LocalStorageService';
import Constants from '../../../services/Constants';

const MY_PLANS_TAB = '1';
const ALL_PLANS_TAB = '2';

export class EmployeePlans extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: localStorage.getItem('last-plans-tab') || MY_PLANS_TAB,
      tooltipGridViewOpen: false,
      tooltipListViewOpen: false,
    };
    this.manageLocalStorage();
  }

  toggleGridViewTooltip = () =>
    this.setState({ tooltipGridViewOpen: !this.state.tooltipGridViewOpen });
  toggleListViewTooltip = () =>
    this.setState({ tooltipListViewOpen: !this.state.tooltipGridViewOpen });

  toggle = (index) => {
    localStorage.setItem('last-plans-tab', index);
    this.setState({ activeTab: index });
  };

  hideUnpublishedPlans = (e) => {
    this.props.saveHideUnpublishedPlans(e.target.checked);
  };

  changeViewModel = (e) => {
    this.props.saveNewViewModel(e);
  };

  manageLocalStorage = () => {
    if (!itemExists(Storages.HIDE_UNPUBLISHED_PLANS)) {
      return this.props.saveHideUnpublishedPlans(false);
    }
    this.props.saveHideUnpublishedPlans(
      getFromLocalStorage(Storages.HIDE_UNPUBLISHED_PLANS)
    );
    this.render();
  };

  isSingleClient = () => {
    const plans = this.props.plans;
    return _.uniqBy(plans, 'clientName').length == 1;
  };

  render() {
    const selected = this.state.activeTab;
    const myPlansTabClass = selected === MY_PLANS_TAB ? 'active' : '';
    const allPlansTabClass = selected === ALL_PLANS_TAB ? 'active' : '';

    return (
      <div className="employeePlans">
        <Row>
          <Col lg={12}>
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={myPlansTabClass}
                  href="#"
                  onClick={() => {
                    this.toggle(MY_PLANS_TAB);
                  }}>
                  My Portfolios
                </NavLink>
              </NavItem>
              <NavItem id="all-portfolios-nav-item">
                <NavLink
                  className={allPlansTabClass}
                  href="#"
                  onClick={() => {
                    this.toggle(ALL_PLANS_TAB);
                  }}>
                  All Portfolios
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
          <Col lg={4} className="switch">
            <div className="switchGroup">
              <FormGroup switch disabled>
                <ButtonGroup size="small">
                  <Button
                    id="tiles-view"
                    size="small"
                    className={`${this.props.portfoliosViewModel ? 'off' : ''}`}
                    onClick={() => this.changeViewModel(false)}>
                    <i className="fa-solid fa-border-all"></i>
                  </Button>
                  <Button
                    id="list-view"
                    size="small"
                    className={`${this.props.portfoliosViewModel ? '' : 'off'}`}
                    onClick={() => this.changeViewModel(true)}>
                    <i className="fa-solid fa-list-ul"></i>
                  </Button>
                </ButtonGroup>
              </FormGroup>

              <Tooltip
                isOpen={this.state.tooltipGridViewOpen}
                target="tiles-view"
                toggle={this.toggleGridViewTooltip}>
                Grid View
              </Tooltip>

              <Tooltip
                isOpen={this.state.tooltipListViewOpen}
                target="list-view"
                toggle={this.toggleListViewTooltip}>
                List View
              </Tooltip>
            </div>
            <FormGroup switch inline className="">
              <Input
                name={Storages.HIDE_UNPUBLISHED_PLANS}
                id="hideUnpublishedPlansSwitch"
                type="switch"
                role="switch"
                checked={this.props.hideUnpublished}
                onChange={(e) => this.hideUnpublishedPlans(e)}
              />
              <Label check>Hide unpublished plans</Label>
            </FormGroup>
          </Col>
        </Row>

        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId={MY_PLANS_TAB}>
            <Disclaimer
              id="myPortfolioMessage"
              name="myPortfolioMessage col-lg-5">
              <ul>
                <li>
                  <b>Published</b> portfolios have an assigned ClientHUB
                  Administrator in Backstop and are visible to clients with
                  permission to access them.
                </li>
                <li>
                  <b>Unpublished</b> portfolios do not have a ClientHUB
                  Administrator in Backstop and will not show for any clients
                  until the ClientHUB Administrator is defined in Backstop.
                </li>
                <li>
                  You can <b>Hide Unpublished Portfolios</b> from this view
                  using the toggle at the top of this page.
                </li>
                <li>
                  See{' '}
                  <a href="https://central.nepc.com/x/OhZwDw">
                    ClientHUB Set-Up Checklist
                  </a>{' '}
                  for more details on configuring the client experience.
                </li>
              </ul>
            </Disclaimer>
            <MyPlans
              plans={this.props.plans}
              isMyPlans={true}
              filterKey={Constants.MY_PLANS}
              singleClient={this.isSingleClient()}
            />
          </TabPane>

          <TabPane tabId={ALL_PLANS_TAB}>
            <AllPlans
              plansByLetter={this.props.plansByLetter}
              requestPlansForLetter={this.props.requestPlansForLetter}
              hideUnpublished={this.props.hideUnpublished}
              emptyLetter={this.props.emptyLetter}
            />
          </TabPane>
        </TabContent>
      </div>
    );
  }
}

EmployeePlans.propTypes = {
  plans: PropTypes.array.isRequired,
  plansByLetter: PropTypes.array,
  requestPlansForLetter: PropTypes.func.isRequired,
  activeTab: PropTypes.string,
  hideUnpublished: PropTypes.bool,
  portfoliosViewModel: PropTypes.bool,
  saveHideUnpublishedPlans: PropTypes.func,
  saveNewViewModel: PropTypes.func,
  emptyLetter: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    hideUnpublished: state.ui.hideUnpublished,
    portfoliosViewModel: state.ui.portfoliosViewModel,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    saveHideUnpublishedPlans: (...a) =>
      dispatch(saveHideUnpublishedPlans(...a)),
    saveNewViewModel: (...a) => dispatch(saveNewViewModel(...a)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeePlans);
